var locale_pt_br = {
    bandContent: 'Conteúdo',
    bandFooter: 'Rodapé',
    bandHeader: 'Cabeçalho',
    clear: 'Limpar',
    contentHeight: 'Altura do conteúdo',
    contentHeightInfo: 'Afeta apenas o tamanho da tela de desenho para colocar os elementos e não o tamanho real da página',
    differentFiles: 'arquivos diferentes ...',
    differentValues: 'valores diferentes ...',
    docElementAlternateBackgroundColor: 'Cor de fundo alternativa',
    docElementAlwaysPrintOnSamePage: 'Sempre na mesma página',
    docElementBarCode: 'Código de barras',
    docElementBorderFrame: 'Bordas Externa',
    docElementBorderFrameRow: 'Bordas externas e horizontais',
    docElementBorderGrid: 'Todas as Bordas',
    docElementBorderNone: 'Nenhum',
    docElementBorderRow: 'Bordas horizontais',
    docElementColor: 'Cor',
    docElementColspan: 'Colspan',
    docElementColumns: 'Colunas',
    docElementConditionalStyle: 'Estilo condicional',
    docElementConditionalStyleCondition: 'Condição',
    docElementContent: 'Texto',
    docElementContentRows: 'Linhas',
    docElementDataSource: 'Fonte de dados',
    docElementDisplayValue: 'Valor de exibição',
    docElementErrorCorrectionLevel: 'Correção de erros',
    docElementErrorCorrectionLevelHigh: 'Alto',
    docElementErrorCorrectionLevelLow: 'Baixo',
    docElementErrorCorrectionLevelMedium: 'Médio',
    docElementErrorCorrectionLevelQuartile: 'Quartil',
    docElementEval: 'Avalie expressão',
    docElementFormat: 'Formato',
    docElementFrame: 'Quadro',
    docElementGroupExpression: 'Expressão de grupo',
    docElementGrowWeight: 'Crescer peso',
    docElementGrowWeightInfo: 'Fator de crescimento para ocupar espaço de colunas ocultas',
    docElementGrowWeightHigh: 'Alto',
    docElementGrowWeightLow: 'baixo',
    docElementHeight: 'Altura',
    docElementImage: 'Imagem',
    docElementImageFile: 'Arquivo de imagem',
    docElementLabel: 'Etiqueta',
    docElementLine: 'Linha',
    docElementLink: 'Link',
    docElementLoadImageErrorMsg: 'O carregamento da imagem falhou',
    docElementPageBreak: 'Quebra de página',
    docElementPattern: 'Padrão',
    docElementPosition: 'Posição (x, y)',
    docElementPositionX: 'Posição (x)',
    docElementPositionY: 'Posição (y)',
    docElementPrintIf: 'Imprimir se',
    docElementPrintSettings: 'Configurações de impressão',
    docElementRemoveEmptyElement: 'Remover quando vazio',
    docElementRepeatGroupHeader: 'Grupo de repetição em cada página',
    docElementRepeatHeader: 'Repetir cabeçalho',
    docElementRichText: 'Rich text',
    docElementRoot: 'Documento',
    docElementSection: 'Seção',
    docElementShrinkToContentHeight: 'Reduzir para a altura do conteúdo',
    docElementSize: 'Tamanho (largura, altura)',
    docElementSource: 'Fonte',
    docElementSpreadsheet: 'Planilha',
    docElementSpreadsheetAddEmptyRow: 'Adicione uma linha vazia abaixo',
    docElementSpreadsheetColspan: 'Colspan',
    docElementSpreadsheetColumn: 'Coluna fixa',
    docElementSpreadsheetHide: 'Esconder',
    docElementSpreadsheetTextWrap: 'Quebra de texto',
    docElementStyle: 'Estilo',
    docElementTable: 'Tabela',
    docElementTableBandPageBreak: 'Quebra de página com cada novo grupo',
    docElementText: 'Texto',
    docElementWidth: 'Largura',
    // documentProperties: 'Propriedades do documento',
    documentProperties: 'Documento',
    documentTabClose: 'Fechar',
    documentTabPdfLayout: 'Layout de PDF',
    documentTabPdfPreview: 'Visualização de PDF',
    documentTabXlsxDownload: 'Download XLSX',
    emptyPanel: 'Painel vazio',
    errorMsgDuplicateParameter: 'Parâmetro já existe',
    errorMsgDuplicateParameterField: 'Campo já existe',
    errorMsgFontNotAvailable: 'Fonte não disponível no servidor',
    errorMsgLoadingImageFailed: 'Falha ao carregar a imagem: $ {info}',
    errorMsgInvalidArray: 'Lista inválida',
    errorMsgInvalidAvgSumExpression: 'A expressão deve conter campo de número de um parâmetro de lista',
    errorMsgInvalidBarCode: 'Conteúdo de código de barras inválido',
    errorMsgInvalidDataSource: 'Fonte de dados inválida',
    errorMsgInvalidDataSourceParameter: 'O parâmetro deve ser uma lista',
    errorMsgInvalidDate: 'Data inválida, o formato esperado é AAAA-MM-DD (ou AAAA-MM-DD hh: mm para data com hora)',
    errorMsgInvalidExpression: 'Expressão inválida: $ {info}',
    errorMsgInvalidExpressionFuncNotDefined: 'Função $ {info} não definida',
    errorMsgInvalidExpressionNameNotDefined: 'Nome $ {info} não definido',
    errorMsgInvalidExpressionType: 'A expressão retorna um tipo inválido',
    errorMsgInvalidLink: 'O link deve começar com http: // ou https: //',
    errorMsgInvalidImage: 'Dados de imagem inválidos, a imagem deve ser codificada em base64',
    errorMsgInvalidImageSource: 'Fonte inválida, url esperado começando com http: // ou https: // respectivamente',
    errorMsgInvalidImageSourceParameter: 'O parâmetro deve ser uma imagem ou string (contendo um url)',
    errorMsgInvalidMap: 'Coleção inválida',
    errorMsgInvalidNumber: 'Número inválido',
    errorMsgInvalidPageSize: 'Tamanho de página inválido',
    errorMsgInvalidParameterData: 'Os dados não correspondem ao parâmetro',
    errorMsgInvalidParameterName: 'O nome deve começar com um caractere ou sublinhado e deve conter apenas caracteres, dígitos e sublinhados (_)',
    errorMsgInvalidPattern: 'Padrão inválido',
    errorMsgInvalidPosition: 'A posição está fora da área',
    errorMsgInvalidSize: 'O elemento está fora da área',
    errorMsgInvalidTestData: 'Dados de teste inválidos',
    errorMsgMissingData: 'Dados ausentes',
    errorMsgMissingDataSourceParameter: 'Parâmetro da fonte de dados não encontrado',
    errorMsgMissingExpression: 'A expressão deve ser definida',
    errorMsgMissingImage: 'Imagem ausente, nenhuma fonte ou arquivo de imagem especificado',
    errorMsgMissingParameter: 'Parâmetro não encontrado',
    errorMsgMissingParameterData: 'Dados para o parâmetro {info} não encontrados',
    errorMsgRepeatGroupHeaderAfterContent: 'Não permitido para grupo após linha de conteúdo',
    errorMsgPlusVersionRequired: 'Requer versão comercial PLUS',
    errorMsgSectionBandNotOnSamePage: 'Faixa de seção não cabe na mesma página',
    errorMsgSectionBandPageBreakNotAllowed: 'Quebra de página manual não permitida',
    errorMsgUnicodeEncodeError: 'O texto contém caracteres não imprimíveis',
    errorMsgUnsupportedImageType: 'A imagem não é compatível com o tipo de imagem (.jpg, .png)',
    footer: 'Rodapé',
    footerDisplay: 'Exibição',
    footerSize: 'Tamanho do rodapé',
    header: 'Cabeçalho',
    headerDisplay: 'Exibição',
    headerFooterDisplayAlways: 'Sempre',
    headerFooterDisplayNotOnFirstPage: 'Não mostrar na primeira página',
    headerSize: 'Tamanho do cabeçalho',
    menuColumnAddLeft: 'Adicionar coluna à esquerda',
    menuColumnAddRight: 'Adicionar coluna à direita',
    menuColumnDelete: 'Apagar coluna',
    menuAlignBottom: 'Alinhamento inferior',
    menuAlignCenter: 'Alinhar centro',
    menuAlignLeft: 'Alinhar à esquerda',
    menuAlignMiddle: 'Alinha no meio',
    menuAlignRight: 'Alinhar à direita',
    menuAlignTop: 'Alinhar topo',
    menuInsertReport: 'Inserir',
    menuInsertReportTip: 'Inserir modelo de relatório',
    menuInsertReportAlert: 'Cole o modelo de relatório aqui para carregar o relatório',
    menuLogReport: 'Relatório',
    menuLogReportTip: 'Debug no console o Modelo de relatório',
    menuPreview: 'Visualizar',
    menuPreviewTip: 'Visualizar Relatório',
    menuRedo: 'Refazer',
    menuRedoTip: 'Repita o último comando desfeito',
    menuRowAddAbove: 'Adicionar linha acima',
    menuRowAddBelow: 'Adicionar linha abaixo',
    menuRowDelete: 'Apagar linha',
    menuSave: 'Salvar',
    menuSaveTip: 'Salvar o relatorio',
    menuToggleGrid: 'Mostrar / ocultar grade',
    menuUndo: 'Desfazer',
    menuUndoTip: 'Desfazer o último comando',
    menuZoomIn: 'Mais Zoom',
    menuZoomOut: 'Menos zoom',
    nameCopySuffix: 'cópia de',
    orientation: 'Orientação',
    orientationBottom: 'Inferior',
    orientationLandscape: 'Paisagem',
    orientationLeft: 'Esquerda',
    orientationPortrait: 'Retrato',
    orientationRight: 'Direita',
    orientationTop: 'Superior',
    reportName: 'Nome do documento',
    pageFormat: 'Formato de página',
    pageFormatA4: 'DIN A4 (210 x 297 mm)',
    pageFormatA5: 'DIN A5 (148 x 210 mm)',
    pageFormatLetter: 'Carta (8,5 x 11,0 polegadas)',
    pageFormatUserDefined: 'Dimensões próprias',
    pageHeight: 'altura',
    pageMargins: 'Margens da página',
    pageWidth: 'largura',
    parameter: 'Parâmetro',
    parameterAddTestData: 'Adicionar linha',
    parameterArrayItemType: 'Tipo de item de lista',
    parameterEditTestData: 'Editar',
    parameterEditTestDataNoFields: 'Nenhum campo definido para esta lista',
    parameterEval: 'Avalie o texto',
    parameterExpression: 'Expressão',
    parameterListType: 'Tipo de lista',
    parameterName: 'Nome',
    parameterNullable: 'Anulável',
    parameterPattern: 'Padrão',
    parameterRowParams: 'Parâmetros de linha',
    parameterSearchPlaceholder: 'Pesquisar parâmetros ...',
    parameterTestData: 'Dados de teste',
    parameterTestDataDatePattern: 'AAAA-MM-DD',
    parameterType: 'Modelo',
    parameterTypeArray: 'Lista',
    parameterTypeAverage: 'Média',
    parameterTypeBoolean: 'boleano',
    parameterTypeDate: 'Data',
    parameterTypeImage: 'Imagem',
    parameterTypeMap: 'Coleção',
    parameterTypeNumber: 'Número',
    parameterTypeSimpleArray: 'Lista Simples',
    parameterTypeString: 'Texto',
    parameterTypeSum: 'Soma',
    parameters: 'Parâmetros',
    parametersDataSource: 'Parâmetros da fonte de dados',
    patternCurrencySymbol: 'Símbolo de moeda padrão',
    patternDate1: 'dia.mês.ano, por exemplo 1.6.1980',
    patternDate2: 'dia.mês.ano (2 dígitos), hora (24h): minuto, por ex. 1.6.80, 14:30',
    patternDate3: 'dia / mês / ano (abreviatura do mês), por ex. 1 / jun / 1980',
    patternDate4: 'mês / dia / ano (dia e mês com zero à esquerda se um único dígito), por ex. 01/06/1980',
    patternLocale: 'Localidade padrão',
    patternNumber1: 'Mostrar separador de milhar',
    patternNumber2: 'Mostra o ponto decimal seguido por 3 casas decimais',
    patternNumber3: 'Mostrar o ponto decimal seguido por um mínimo de 2 e máximo de 4 casas decimais',
    patternNumber4: 'Mostrar separador de milhar e ponto decimal seguido de 2 casas decimais',
    patternNumber5: 'Mostrar o símbolo da moeda na frente do número',
    patternSeparatorDates: '--- Padrões de data ---',
    patternSeparatorNumbers: '--- Padrões numéricos ---',
    plusFeatureInfo: 'versão PLUS comercial',
    select: 'selecione ...',
    style: 'Estilo',
    styleAlignment: 'Alinhamento',
    styleBackgroundColor: 'Cor de fundo',
    styleBold: 'Negrito',
    styleBorder: 'Bordas',
    styleBorderAll: 'Todas as Bordas',
    styleBorderColor: 'Cor da borda',
    styleBorderWidth: 'Largura da borda',
    styleFont: 'Fonte',
    styleFontSizeUnit: 'pt',
    styleHAlignmentCenter: 'Centralizar',
    styleHAlignmentLeft: 'Esquerda',
    styleHAlignmentJustify: 'Justificar',
    styleHAlignmentRight: 'Direita',
    styleItalic: 'itálico',
    styleLineSpacing: 'Espaçamento entre linhas',
    styleName: 'Nome',
    styleNone: 'Nenhum',
    stylePadding: 'Recuo',
    styleStrikethrough: 'Tachado',
    styleTextColor: 'Cor do texto',
    styleTextStyle: 'Estilo do texto',
    styleUnderline: 'Sublinhado',
    styleVAlignmentBottom: 'Inferior',
    styleVAlignmentMiddle: 'Centro',
    styleVAlignmentTop: 'Superior',
    styles: 'Estilos'
};

export default locale_pt_br;
